module.exports = __webpack_public_path__ + "static/media/approve-tell.32ea5013.png";